const DEFAULT_GUEST_ORDER_INSTRUCTIONS =
  "Pro tip: Your order is powered by Goldi's algorithm - follow these instructions to get your customized dish!";

const HYATT_MAUI_IN_ROOM_DINING_SLUG = 'hyatt_regency_maui_inroomdining';

const DEFAULT_GUEST_ORDER_HEADER = 'Place Your Order:';
const HYATT_MAUI_IN_ROOM_DINING_HEADER =
  'Dial Room Service to Place Your Order';

const HYATT_MAUI_IN_ROOM_DINING_INSTRUCTIONS =
  'Be sure to read your whole order to the person on the other end of the line, including any special instructions or modifications written below. This is the best way to ensure that your meal is "Just Right".';

const DEFAULT_GUEST_ORDER_ACTION_LABEL = 'All Done !';
const HYATT_MAUI_IN_ROOM_DINING_ACTION_LABEL =
  'Enjoying Goldi? Register Now!';
const DEFAULT_GUEST_ORDER_MENU_ACTION_LABEL = 'View Cart';
const HYATT_MAUI_IN_ROOM_DINING_MENU_ACTION_LABEL = 'View Order';

const isHyattMauiInRoomDining = (restaurantUrlSlug?: string) =>
  restaurantUrlSlug?.toLowerCase() === HYATT_MAUI_IN_ROOM_DINING_SLUG;

export const getGuestOrderInstructions = (restaurantUrlSlug?: string) =>
  isHyattMauiInRoomDining(restaurantUrlSlug)
    ? HYATT_MAUI_IN_ROOM_DINING_INSTRUCTIONS
    : DEFAULT_GUEST_ORDER_INSTRUCTIONS;

export const getGuestOrderHeader = (restaurantUrlSlug?: string) =>
  isHyattMauiInRoomDining(restaurantUrlSlug)
    ? HYATT_MAUI_IN_ROOM_DINING_HEADER
    : DEFAULT_GUEST_ORDER_HEADER;

export const getGuestOrderActionLabel = (restaurantUrlSlug?: string) =>
  isHyattMauiInRoomDining(restaurantUrlSlug)
    ? HYATT_MAUI_IN_ROOM_DINING_ACTION_LABEL
    : DEFAULT_GUEST_ORDER_ACTION_LABEL;

export const getGuestOrderMenuActionLabel = (restaurantUrlSlug?: string) =>
  isHyattMauiInRoomDining(restaurantUrlSlug)
    ? HYATT_MAUI_IN_ROOM_DINING_MENU_ACTION_LABEL
    : DEFAULT_GUEST_ORDER_MENU_ACTION_LABEL;

export default getGuestOrderInstructions;
